import {ControlBuilder} from './control-builder.type';
import {FieldTypeEnum} from './field-type.enum';

export type FieldTypeToControlBuilder = Map<FieldTypeEnum, ControlBuilder>;

